
















import { Vue, Component, Prop } from 'vue-property-decorator';

import MonthSlotGeneric from './MonthSlotGeneric.vue';
import CalendarAction from '../CalendarAction.vue';
import IconRemove from '@/components/icons/Remove.vue';
import IconEdit from '@/components/icons/Edit.vue';

import { VacationSlot } from '../types';
import { ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {
        MonthSlotGeneric,
        CalendarAction,
        IconRemove,
        IconEdit,
    },
})
export default class MonthSlotVacation extends Vue {
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({ required: true }) slots!: [VacationSlot]

    get vacationSlot() {
        return this.slots[0];
    }

    viewVacation() {
        this.$emit('select:vacation', this.vacationSlot);
    }
}
